export function getCurrentDateTime() {
  let currentDate = new Date();

  // Get day, month, year
  let day = currentDate.getDate().toString().padStart(2, "0");
  let month = (currentDate.getMonth() + 1).toString().padStart(2, "0"); // Month is zero-based
  let year = currentDate.getFullYear();

  // Get hours, minutes, seconds
  let hours = currentDate.getHours().toString().padStart(2, "0");
  let minutes = currentDate.getMinutes().toString().padStart(2, "0");
  let seconds = currentDate.getSeconds().toString().padStart(2, "0");

  // Form the date string in the desired format
  let formattedDateTime = `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;

  return formattedDateTime;
}

export function convertToArabicDate(dateString) {
  if (
    !dateString ||
    typeof dateString !== "string" ||
    !/^\d{4}-\d{2}-\d{2}$/.test(dateString)
  ) {
    console.error("Invalid date string format. Please use YYYY-MM-DD.");
    return null;
  }

  const parts = dateString.split("-");
  const year = parseInt(parts[0], 10);
  const month = parseInt(parts[1], 10);
  const day = parseInt(parts[2], 10);

  const arabicMonths = [
    "يناير",
    "فبراير",
    "مارس",
    "أبريل",
    "ماي",
    "يونيو",
    "يوليوز",
    "غشت",
    "شتنبر",
    "أكتوبر",
    "نونبر",
    "دجنبر",
  ];

  if (month < 1 || month > 12) {
    console.error("Invalid month in date string.");
    return null;
  }

  const arabicMonthName = arabicMonths[month - 1];

  return `${day} ${arabicMonthName} ${year}`;
}
export function getMonthYearInFrench(dateStr) {
  const date = new Date(dateStr);
  return date.toLocaleDateString("fr-FR", {
    year: "numeric",
    month: "long",
  });
}

export function getMonthYearInArabic(dateStr) {
  const arabicMonths = [
    "يناير",
    "فبراير",
    "مارس",
    "أبريل",
    "ماي",
    "يونيو",
    "يوليوز",
    "غشت",
    "شتنبر",
    "أكتوبر",
    "نونبر",
    "دجنبر",
  ];

  const date = new Date(dateStr);
  const month = arabicMonths[date.getMonth()];
  const year = date.getFullYear();
  return `${month} ${year}`;
}
